export const loadAsyncScript = url => {
  const script = document.createElement('script')
  script.async = true
  script.src = url

  document.head.appendChild(script)
}

export const loadTrackingPixel = url => {
  const img = document.createElement('img')
  img.src = url
  img.width = 1
  img.height = 1
  img.style.border = 0

  document.body.appendChild(img)
}

export const submitSignupPixels = () => {
  loadTrackingPixel('//conv.indeed.com/pagead/conv/7672182510826283/?script=0')
  if (window.snaptr) {
    window.snaptr('init', 'b9e58400-4558-41f7-9674-a58b3d435599')
    window.snaptr('track', 'PAGE_VIEW')
  }
  if (window.rdt) {
    window.rdt('track', 'SignUp')
  }
}

export const submitConversionPixels = () => {
  loadAsyncScript('https://t1.jobcase.com/js/jc_conversion_path_tag.min.js')
  window.ttq.instance('C28SIKVMU8Q03RAIDKT0').track('CompleteRegistration')
}
